import { toArray as d } from "../../../utils/helpers.js";
import { getFormControlValueAsString as f } from "../../../utils/helpers.form.js";
import { IressSelectOption as h } from "../components/SelectOption.js";
const o = (i) => d(i).reduce((e, r) => {
  const { type: t, props: s } = r || {}, { label: p, children: n } = s || {};
  if (t === "optgroup")
    e = [
      ...e,
      {
        label: p,
        children: o(n)
      }
    ];
  else if ([h, "option"].includes(t)) {
    const l = { ...s };
    delete l.children, e = [
      ...e,
      {
        ...l,
        label: n
      }
    ];
  } else
    (n || Array.isArray(r)) && (e = [
      ...e,
      ...o(n || r)
    ]);
  return e;
}, []), S = (i, e = []) => e.reduce((r, t) => r || (t.children ? S(i, t.children) : f(t.value) === i ? t.value : r), void 0);
export {
  S as findValueFromStringInSelectOptions,
  o as mapNodesToSelectOptions
};
